import { render, staticRenderFns } from "./gongdan_buliang.vue?vue&type=template&id=50a42906&scoped=true&"
import script from "./gongdan_buliang.vue?vue&type=script&lang=js&"
export * from "./gongdan_buliang.vue?vue&type=script&lang=js&"
import style0 from "./gongdan_buliang.vue?vue&type=style&index=0&id=50a42906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a42906",
  null
  
)

export default component.exports